module.exports = __webpack_public_path__ + "img/smurf.c0d41d48.png";